
<template>
    <div class="admin-login-container">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6 col-lg-4">
            <div class="card shadow-sm mt-5">
              <div class="card-body p-4">
                <div class="text-center mb-4">
                  <h2 class="mb-1">Administration</h2>
                  <p class="text-muted">Connectez-vous pour accéder au panneau d'administration</p>
                </div>
                
                <div v-if="error" class="alert alert-danger">{{ error }}</div>
                
                <form @submit.prevent="handleLogin">
                  <div class="mb-3">
                    <label for="email" class="form-label">Email</label>
                    <input 
                      type="email" 
                      id="email" 
                      class="form-control" 
                      v-model="email" 
                      required
                    >
                  </div>
                  
                  <div class="mb-4">
                    <label for="password" class="form-label">Mot de passe</label>
                    <input 
                      type="password" 
                      id="password" 
                      class="form-control" 
                      v-model="password" 
                      required
                    >
                  </div>
                  
                  <button 
                    type="submit" 
                    class="btn btn-primary w-100" 
                    :disabled="loading"
                  >
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                    Se connecter
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import { ref } from 'vue';
  import { useRouter } from 'vue-router';
  import { adminService } from '@/services/api';
  
  export default {
    name: 'AdminLogin',
    setup() {
      const router = useRouter();
      const email = ref('');
      const password = ref('');
      const error = ref('');
      const loading = ref(false);
      
    
const handleLogin = async () => {
  loading.value = true;
  error.value = '';
  
  try {
    // Enlever l'assignation à "response" puisque nous ne l'utilisons pas
    await adminService.loginAdmin({
      email: email.value,
      password: password.value
    });
    
    // Si on arrive ici, c'est que la connexion a réussi et l'utilisateur est admin
    router.push({ name: 'AdminDashboard' });
    
  } catch (err) {
    console.error('Erreur détaillée:', err);
    // Afficher un message d'erreur plus spécifique
    if (err.response && err.response.status === 404) {
      error.value = 'Erreur de connexion au serveur. Veuillez réessayer plus tard.';
    } else if (err.message === 'Accès non autorisé - Compte non administrateur') {
      error.value = 'Ce compte n\'a pas les privilèges administrateur.';
    } else {
      error.value = err.response?.data?.message || err.message || 'Identifiants invalides ou accès non autorisé';
    }
  } finally {
    loading.value = false;
  }
};
      return {
        email,
        password,
        error,
        loading,
        handleLogin
      };
    }
  };
  </script>
  
  <style>
  /* Pour s'assurer que tous les styles sont bien chargés */
  @import 'bootstrap/dist/css/bootstrap.min.css';
  @import '@fortawesome/fontawesome-free/css/all.min.css';
  
  .admin-login-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    padding: 2rem 1rem;
    background-color: #f8f9fa;
  }
  
  .card {
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  }
  
  .btn-primary {
    background-color: #000;
    border-color: #000;
  }
  
  .btn-primary:hover {
    background-color: #333;
    border-color: #333;
  }
  </style>